import { createContext } from 'react'
import Page from 'shared/types/Page'

const MenuContext = createContext<Page[] | null>(null!)

export default MenuContext